import template from './bill-payment-only.html';
import controller from './bill-payment-only.controller';
import './bill-payment-only.scss';

let BillPaymentOnlyComponent = {
  bindings: {},
  template,
  controller
};

export default BillPaymentOnlyComponent;



// WEBPACK FOOTER //
// ./src/app/pages/bill-payment-only/bill-payment-only.component.js